/* ============================================================
   brand-persist.js
   Persistencia ligera de la marca activa (progressive enhancement).
   El core funciona sin JS: la marca se resuelve server-side por contenido.
   Aquí solo guardamos la selección explícita (?brand / click en logo) en
   una cookie y marcamos <html data-active-brand> para hooks de estilo.
   ============================================================ */
(function () {
  var COOKIE = 'bkp_brand';
  var MAX_AGE = 60 * 60 * 24 * 30; // 30 días

  function setCookie(name, value) {
    try {
      document.cookie =
        name + '=' + encodeURIComponent(value) +
        '; path=/; max-age=' + MAX_AGE + '; SameSite=Lax';
    } catch (e) {}
  }

  function getCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }

  function getParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  // 1. Si llega ?brand=..., persistir la selección.
  var urlBrand = getParam('brand');
  if (urlBrand) setCookie(COOKIE, urlBrand);

  // 2. Reflejar la marca actual en <html> (para estilos/analytics).
  var current = urlBrand || getCookie(COOKIE);
  if (current) document.documentElement.setAttribute('data-active-brand', current);

  // 3. Guardar la selección al hacer click en un logo de marca.
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest && e.target.closest('[data-brand-logo]');
      if (!link) return;
      var handle = link.getAttribute('data-brand-logo');
      if (handle) setCookie(COOKIE, handle);
    },
    true
  );
})();
